import React from "react";

const Loading = () => {
  return <div className="spinner"></div>;
};

export default Loading;
